/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * The type for a mutator icon. Used for registration and access.
 *
 * @internal
 */
export const MUTATOR_TYPE = 'mutator';

/**
 * The type for a warning icon. Used for registration and access.
 *
 * @internal
 */
export const WARNING_TYPE = 'warning';

/**
 * The type for a comment icon. Used for registration and access.
 *
 * @internal
 */
export const COMMENT_TYPE = 'comment';
